import HomePage from '@/pages/HomePage';
import DataHome from '@/pages/DataHome';
import DataListing from '@/pages/DataListing';
import DataView from '@/pages/DataView';
import ModelListing from '@/pages/ModelListing';
import ModelView from '@/pages/ModelView';
import TemplateView from '@/pages/TemplateView';
import NotFound from '@/pages/NotFound';

export const routes = [
  // Home Pages with Overviews
  { 
    name: 'Home',
    path: '/',
    component: HomePage,
    alias: '/home/'
  },
  { 
    name: 'Home: Forecasts',
    path: '/home/forecasts',
    component: HomePage
  },
  { 
    name: 'Home: Data',
    path: '/home/data',
    component: DataHome
  },
  { 
    name: 'Home: Models',
    path: '/home/models',
    component: HomePage
  },
  { 
    name: 'About',
    path: '/about',
    component: HomePage
  },


  // Data Pages
  { name: 'Data Listing', path: '/data', component: DataListing},
  { name: 'Data View',
    path: '/data/:dataID',
    component: DataView,
    props: (route) => ({
      'dataID': +route.params.dataID
    })
  },


  // Models
  {
    name: 'Model Listing',
    path: '/model',
    component: ModelListing
  },
  { 
    name: 'Model View',
    path: '/model/:modelID',
    component: ModelView,
    props: (route) => ({
      'modelID': +route.params.modelID
    })
  },


  // Model Templates
  { 
    name: 'Template View',
    path: '/template/:templateName',
    component: ModelView,
    props: (route) => ({
      'templateName': route.params.templateName
    })
  },
  

  // Catch-all for any route
  { 
    name: '404 Page',
    path: '*',
    component: NotFound
  }
]